import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Form, Breadcrumb, Card } from 'react-bootstrap';
import axios from "axios";
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import moment from "moment";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { useParams, useNavigate } from "react-router-dom";
import { getSocket } from "../../context/socket";
import { buildUserOptions, mergeUsersById, normalizeUserIds } from '../../utils/userOptions';

const PRIORITY_OPTIONS = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
];
const EditProject = () => {
    const { accessToken } = useAuth(); // Get the access token from the context
    const { project_id } = useParams(); // Get project_id from route params
    const navigate = useNavigate(); // React Router's navigate hook
    const socket = getSocket();
    const [brands, setBrands] = useState([]);
    const [users, setUsers] = useState([]);
    const [projectData, setProjectData] = useState({
        project_name: "",
        brand_id: "",
        start_date: "",
        end_date: "",
        description: "",
        priority: "Medium",
        lead_id: "",
        member_id: [],
        project_files: "",
    });
    const [projectMembers, setProjectMembers] = useState([]);
    const [projectLead, setProjectLead] = useState(null);
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
    });

    // Fetch all users and brands
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetch-all-users`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setUsers(data);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        const fetchBrands = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetchallbrands`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setBrands(data);
            } catch (error) {
                console.error("Error fetching brands:", error);
            }
        };

        const fetchProject = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/projects/${project_id}`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                const project = data.project;

                // Set the project data and adjust the date range
                setProjectLead(project.lead || null);
                setProjectMembers(project.members || []);
                setProjectData({
                    project_name: project.project_name,
                    brand_id: project.brand.brand_id,
                    start_date: project.start_date,
                    end_date: project.end_date,
                    description: project.description,
                    priority: project.priority,
                    lead_id: Number(project.lead.user_id),
                    member_id: normalizeUserIds(project.members.map((member) => member.user_id)),
                    project_files: project.project_files,
                });
                setDateRange({
                    startDate: moment(project.start_date),
                    endDate: moment(project.end_date),
                });
            } catch (error) {
                console.error("Error fetching project:", error);
            }
        };
        fetchProject();
        fetchUsers();
        fetchBrands();
    }, [accessToken, project_id]);

    const userOptions = useMemo(
        () => buildUserOptions(users, mergeUsersById(projectLead ? [projectLead] : [], projectMembers)),
        [users, projectLead, projectMembers]
    );

    const setProjectField = (name, value) => {
        setProjectData((prev) => ({ ...prev, [name]: value }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProjectField(name, value);
    };

    const handleDateRangeChange = (start, end) => {
        setDateRange({ startDate: start, endDate: end });
        setProjectData({
            ...projectData,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
        });
    };

    // Handle form submission to edit project
    const handleSubmit = (e) => {
        e.preventDefault();
    
        const updatedProject = {
            project_id,
            ...projectData,
        };
    
       
    
        // Clean up previous listeners
        socket.off('edit-project-success');
        socket.off('edit-project-response');
    
        // Handle success
        socket.once('edit-project-success', (response) => {
            
            navigate(`/Graphe/dashboard/projects_details/${project_id}`);
           
        });
    
        // Handle error
        socket.once('edit-project-response', (response) => {
            console.error("Error editing project:", response.message);
        });
    
        // Emit the update
        socket.emit('editProject', updatedProject);
    };
    




    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={6} className="mb-4">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                <i className="pi pi-angle-left"></i> Back
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>Edit Project</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col md={12} lg={12}>
                        <Card>
                            <Card.Body>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Group controlId="formProjectName">
                                                <Form.Label>Project Name</Form.Label>
                                                <InputText
                                                    name="project_name"
                                                    value={projectData.project_name}
                                                    onChange={handleChange}
                                                    className="form-control m-0"

                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Group controlId="formBrand">
                                                <Form.Label>Brand</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="brand_id"
                                                    className="m-0"
                                                    value={projectData.brand_id}
                                                    onChange={handleChange}
                                                    disabled
                                                >
                                                    {brands.map((brand) => (
                                                        <option key={brand.brand_id} value={brand.brand_name}>
                                                            {brand.brand_name}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Label>Date Range</Form.Label>
                                            <DateRangePicker
                                                initialSettings={{
                                                    startDate: dateRange.startDate,
                                                    endDate: dateRange.endDate,
                                                    locale: { format: 'DD/MM/YYYY' }

                                                }}
                                                onCallback={(start, end) => handleDateRangeChange(start, end)}
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control w-full m-0"
                                                    placeholder="Select Date Range"
                                                    readOnly
                                                />
                                            </DateRangePicker>
                                        </Col>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Group controlId="formLead">
                                                <Form.Label>Lead</Form.Label>
                                                <Dropdown
                                                    name="lead_id"
                                                    value={projectData.lead_id}
                                                    options={userOptions}
                                                    onChange={(e) => setProjectField('lead_id', e.value)}
                                                    placeholder="Select a project lead"
                                                    className="w-full m-0"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Group controlId="formMembers">
                                                <Form.Label>Members</Form.Label>
                                                <MultiSelect
                                                    value={projectData.member_id}
                                                    options={userOptions}
                                                    onChange={(e) => setProjectField('member_id', e.value || [])}
                                                    placeholder="Select team members"
                                                    className="w-full position-relative m-0"
                                                    display="chip"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4} className="mb-3">
                                            <Form.Group controlId="formPriority">
                                                <Form.Label>Priority</Form.Label>
                                                <Dropdown
                                                    value={projectData.priority}
                                                    options={PRIORITY_OPTIONS}
                                                    onChange={(e) => setProjectField('priority', e.value)}
                                                    placeholder="Select priority"
                                                    className="position-relative m-0 w-full"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12} lg={12} className="px-2 mb-3">
                                            <label className="mb-2">Project Files (URL)</label>
                                            <InputTextarea
                                                rows={2}
                                                name="project_files"
                                                value={projectData.project_files}
                                                onChange={handleChange}
                                                placeholder="Enter a link or URL for project files"
                                                className="w-full"
                                            />
                                        </Col>


                                        <Col md={12}>
                                            <Form.Group controlId="formDescription">
                                                <Form.Label>Description</Form.Label>
                                                <InputTextarea
                                                    name="description"
                                                    value={projectData.description}
                                                    onChange={handleChange}
                                                    rows={10}
                                                    className="form-control h-auto m-0"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="d-flex justify-content-end align-items-center">
                                        <Button type="submit" severity="info" label="Save Changes" className="mt-3 py-2" />
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
        </>
    );
};
export default EditProject
